import { BsArrowBarDown, BsArrowBarUp } from 'react-icons/bs';
import { Container } from 'react-bootstrap';
import { FC, useState } from 'react';
import { generalBlue } from 'src/app-config';
import { HTHShareAllBuildingsButtons } from './HTHShareAllBuildingsButtons';
import { typeHTHTerritory, typeTerritoryNumber } from '@monorepo/models';
import { useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    hthTerritory: typeHTHTerritory;
    territoryNumber: typeTerritoryNumber;
};

export const HTHShare: FC<propsType> = ({ hthTerritory, territoryNumber }) => {
    const [showShareTerritorySection, setShowShareTerritorySection] = useState(false);
    const isMobile = useGetIsMobile();
    
    return (
        <Container>
            <h1 className={'container pointer btn-general-blue text-white py-3'}
                style={{
                    backgroundColor: generalBlue,
                    fontSize: isMobile ? '1.8rem' : '2.4rem',
                    fontWeight: 'bold',
                    margin: isMobile ? '30px auto 20px auto' : '60px auto 40px auto',
                    textAlign: 'center'
                }}
                onClick={() => setShowShareTerritorySection(x => !x)}
            >
                {showShareTerritorySection ?
                    <>OCULTAR COMPARTIR <BsArrowBarUp size={isMobile ? '1.6rem' : '1.4rem'} /></>
                    :
                    <>VER COMPARTIR <BsArrowBarDown size={isMobile ? '1.6rem' : '1.4rem'} /></>
                }
            </h1>
            {showShareTerritorySection &&
                <HTHShareAllBuildingsButtons
                    hthTerritory={hthTerritory}
                    territoryNumber={territoryNumber}
                />
            }   
        </Container>
    );
}
